skrilla.service('productFeeReportService', function() {

    function buildTableForEntries(entries){
        if(entries !== undefined && entries !== ""){
            let rows = entries.split("\n")
            let data = rows.splice(1).map((row) => {
                let obj = {};
                row.split(",").forEach((data, hIndex) => {
                   obj[`h${hIndex}`] =  data;
                });
                return obj;
            });
            let columns = rows[0].split("\",").map((header, index) => {
                return {title: header, field: `h${index}`};
            });
            return {
                columns,
                isSkrillaTable: true,
                data
            }
        }
    }
    return {
        buildTableForEntries: buildTableForEntries
    };
});
